import { useState } from "react";
import BASE_URL from "../Utilities/BASE_URL";
import { useTranslation } from "react-i18next";
const usePut = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);
  const { i18n } = useTranslation();
  const putData = async (endpoint, putData, token) => {
    setIsLoading(true);
    setIsError(null);
    setData(null);

    try {
      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if token is provided
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      console.log("Request headers:", headers);

      const response = await fetch(`${BASE_URL}/${i18n.language}/${endpoint}`, {
        method: "PUT",
        headers,
        body: JSON.stringify(putData),
        credentials: "include",
        mode: "cors",
      });

      // Try to get response body regardless of status
      let responseBody;
      try {
        responseBody = await response.json();
        console.log("Response body:", responseBody);
      } catch (e) {
        console.error("Failed to parse response as JSON:", e);
        responseBody = { message: "Invalid response format" };
      }

      if (!response.ok) {
        throw new Error(
          responseBody.message ||
            `Request failed with status ${response.status}`
        );
      }

      setData(responseBody);
      return responseBody;
    } catch (error) {
      console.error("PUT request error:", error);
      setIsError(error.message || "An error occurred while updating data");
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, isError, putData };
};

export default usePut;
